import { combineReducers } from 'redux';

import contactInfo from './contactInfo';
import documentId from './documentId';
import host from './host';
import isFetching from './isFetching';
import participantId from './participantId';
import requester from './requester';
import signingMethodType from './signingMethodType';

export default combineReducers({
  contactInfo,
  documentId,
  isFetching,
  participantId,
  requester,
  signingMethodType,
  host,
});
